import { initCarousels } from './home/Slider';

(async ({
  featureFlags,
} = {}) => {
  initCarousels();

  if (featureFlags?.tire_finder) {
    const { initializeTireFinder } = await import(
      /* webpackChunkName: "initializeTireFinder" */
      './components/TireFinder/initializeTireFinder'
    );
    initializeTireFinder();
  }
})(window.drupalSettings);
